class FAQ {
  constructor(contentfulNode) {
    this.question = contentfulNode?.question;
    this.answerRichJSON = contentfulNode?.answer;
  }
}

export default FAQ;
